module.exports = __webpack_public_path__ + "static/media/kico.83b3e6e6.jpg";